/**
 * ConfirmDelete component
 */

// React
import React, { FC } from 'react';

// Libraries
import {
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from '@mui/material';

// Utils
import { hostName } from 'utils/helper/common';

// Interface
interface ConfirmDeleteModalProps {
  open: boolean;
  url?: string;
  messages?: string;
  handleClose: () => void;
  handleConfirmDelete: () => void;
}

// Component
const ConfirmDeleteModal: FC<ConfirmDeleteModalProps> = ({
  open,
  url = hostName,
  messages = 'この項目を削除して宜しいですか？',
  handleClose,
  handleConfirmDelete,
}) => {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md">
      <DialogTitle sx={{ marginBottom: '10px' }}>{url} の内容</DialogTitle>
      <DialogContent>
        <DialogContentText color="#000000">{messages}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ height: '30px', color: '#6EC8E2', border: '1px solid #6EC8E2' }}
          onClick={handleClose}
          variant="outlined"
        >
          キャンセル
        </Button>
        <Button
          sx={{ width: '100px', height: '30px' }}
          onClick={handleConfirmDelete}
          color="primary"
          variant="contained"
          autoFocus
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
